import { MapGeoJSONFeature } from "maplibre-gl";
import { Feature, Geometry } from "geojson";

import {
  CIRCE_RADIUS_SOURCE_ID,
  COUNTRY_SOURCE_ID,
  MAPBOX_GL_DRAW_SOURCE_ID,
  ROUTING_SOURCE_ID
} from "@/constants/map";
import { SelectedFeature } from "@/types/map";

// Non-clickable map layers
const NON_CLICKABLE_LAYERS = [
  COUNTRY_SOURCE_ID,
  CIRCE_RADIUS_SOURCE_ID,
  ROUTING_SOURCE_ID,
  MAPBOX_GL_DRAW_SOURCE_ID
];

interface MapFeature extends Feature<Geometry> {
  source?: string;
  id?: string | number;
}

// Helper: Generate consistent feature identifier
export const createFeatureId = (source?: string, id?: string | number) =>
  `${source}-${id}`;

// Helper: Check if feature is a base layer (non-clickable)
export const isBaseLayerFeature = (feature: MapGeoJSONFeature) => {
  return (
    NON_CLICKABLE_LAYERS.some((layerId) =>
      feature.layer.id.includes(layerId)
    ) || !!feature.source?.includes("centroid") // Layers that have `centroid` source i.e. for label and ranking text, should not be clickable
  );
};

// Helper: Find the first clickable feature
export const findClickableFeature = (features: MapGeoJSONFeature[]) => {
  return features.find((feature) => !isBaseLayerFeature(feature));
};

// Helper: Check if feature is already selected
export const isFeatureAlreadyActive = (
  feature: MapFeature,
  currentSelection: SelectedFeature | null,
  comparisonFeatures: SelectedFeature[]
) => {
  const featureId = createFeatureId(feature.source, feature.id);
  const selectedId = createFeatureId(
    currentSelection?.source,
    currentSelection?.id
  );

  return (
    featureId === selectedId ||
    comparisonFeatures.some((f) => f.id === feature.id)
  );
};
